import { render, staticRenderFns } from "./SettingsMandate.vue?vue&type=template&id=19b67670&scoped=true&"
import script from "./SettingsMandate.vue?vue&type=script&lang=js&"
export * from "./SettingsMandate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMandate.vue?vue&type=style&index=0&id=19b67670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b67670",
  null
  
)

export default component.exports